import React, { useContext, createContext } from "react";
import axios from "../api/HttpClient";
import { useNavigate } from "react-router-dom";
import TokenHelper from "../helpers/TokenHelper";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const auth = useProvideAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  return useContext(AuthContext);
};

function useProvideAuth() {

  const navigate = useNavigate();

  const login = async (username, password) => {
    let loginAttempt = null;

    try {
      const response = await axios({
        method: "post",
        url: "/login",
        data: {
          anmeldename: username,
          passwort: password
        },
      });

      if (response.status === 200) {
        TokenHelper.setLocalAccessToken(response.data.token);
        TokenHelper.setLocalRefreshToken(response.data.refreshToken);
        loginAttempt = response.data.authenticated;
      }
    } catch (error) {
      console.error(error);
      if (error.response) {
        loginAttempt = error.response.data?.authenticated;

        //if (error.response.status === 401) {
          //navigate("/login", { replace: true });
        //}
      }
    }

    return loginAttempt;
  };

  const changePassword = async (username, password, newPassword, newPasswordRepeat) => {
    let changePasswordAttempt = null;

    try {
      const response = await axios({
        method: "post",
        url: "/change-password",
        data: {
          anmeldename: username,
          passwort: password,
          passwortNeu: newPassword,
          passwortNeuWiederholung: newPasswordRepeat
        },
      });

      if (response.status === 200) {
        changePasswordAttempt = response.data.authenticated;
      }
    } catch (error) {
      console.error(error);
      if (error.response) {
        changePasswordAttempt = error.response.data?.authenticated;
      }
    }

    return changePasswordAttempt;
  };

  const isPasswordExpired = async () => {
    let passwordExpired = null;

    try {
      const response = await axios({
        method: "post",
        url: "/password-expired",
        data: {}
      });

      if (response.status === 200) {
        passwordExpired = response.data.expired;
      }
    } catch (error) {
      console.error(error);
      if (error.response) {
        passwordExpired = error.response.data?.expired;
      }
    }

    return passwordExpired;
  };

  const logout = () => {
    TokenHelper.clearTokens();
    navigate("/login", { replace: true });
  };

  const refreshAccessToken = async () => {
    let result = null;

    try {
      const response = await axios({
        method: "post",
        url: "/refresh-token",
        data: {
          refreshToken: TokenHelper.getLocalRefreshToken().encodedToken
        }
      });

      if (response.status === 200) {
        TokenHelper.setLocalAccessToken(response.data.token);
        result = true;
      }
    } catch (error) {
      console.error(error);
      if (error.response) {
        result = false;
      }
    }

    return result;
  };

  const existsAccessToken = () => {
    const accessToken = TokenHelper.getLocalAccessToken();
    return accessToken && accessToken.encodedToken && accessToken.decodedToken;
  }

  const isRefreshTokenExpired = () => {
    const refreshToken = TokenHelper.getLocalRefreshToken();
    let isRefreshTokenExpired = false;
    if (refreshToken && refreshToken.encodedToken && refreshToken.decodedToken) {
      isRefreshTokenExpired = refreshToken.decodedToken.exp < Date.now() / 1000;
    }
    return isRefreshTokenExpired;
  }

  return {
    login,
    logout,
    changePassword,
    refreshAccessToken,
    existsAccessToken,
    isRefreshTokenExpired,
    isPasswordExpired
  };
}
